import { LoaderError, TransportError } from '../errors';
import type { LoaderContext } from '../types';

export interface GetSubscriptionInput extends Record<string, unknown> {
  subscriptionId?: string;
  providerName?: string;
  accountId?: string;
  countryCode?: string;
  isStripe?: boolean;
  searchByAccountId?: boolean;
  noCache?: boolean;
  noCouponCache?: boolean;
}

const ENDPOINT = 'subscription.getSubscription';

export async function getSubscription<TData>(
  ctx: LoaderContext,
  input: GetSubscriptionInput,
): Promise<TData> {
  try {
    const response = await ctx.transport.getSubscription(input);
    if (!response) {
      throw new LoaderError({
        type: 'Unknown',
        status: 500,
        endpoint: ENDPOINT,
        retryable: false,
        cause: new Error('Transport did not return a response.'),
      });
    }

    return response.data as TData;
  } catch (error) {
    if (error instanceof TransportError) {
      throw new LoaderError({
        ...error.details,
        endpoint: error.details.endpoint ?? ENDPOINT,
        cause: error,
      });
    }

    throw new LoaderError({
      type: 'Unknown',
      status: 500,
      endpoint: ENDPOINT,
      retryable: false,
      cause: error,
    });
  }
}
